import { isNullOrUndefined } from "ceres/app/helper/utils";
import { setUrlParam } from "ceres/app/services/UrlService";

import {getContinentCode, getCurrencyByCountry} from "~/app/helper/Country";
import {jQueryGet} from "../../helper/jQueryGet";

const ApiService = require("ceres/app/services/ApiService");

const state =
    {
        shippingCountries: [],
        shippingCountryId: null,
        currentPriceType: 'b2c',
        guestMail: '',
        noSwitchCountry: false,
        reload: true
    };

const mutations =
    {
        setShippingCountries(state, shippingCountries)
        {
            state.shippingCountries = shippingCountries;
        },

        setShippingCountryId(state, shippingCountryId)
        {
            shippingCountryId = parseInt(shippingCountryId);

            if (shippingCountryId !== state.shippingCountryId && !App.isSSR)
            {
                document.dispatchEvent(new CustomEvent("afterShippingCountryChanged", {detail: shippingCountryId}));

                if(!isNullOrUndefined(state.shippingCountryId))
                {
                    const newShippingCountry = state.shippingCountries.find(country => country.id === shippingCountryId);
                    let currency = null;

                    if(!isNullOrUndefined(newShippingCountry))
                    {
                        const continentCode = getContinentCode(newShippingCountry);
                        currency = getCurrencyByCountry(newShippingCountry, continentCode);
                    }

                    /**
                     * In the first step (detection) of checkout no reload is necessary for delivery country switch.
                     * After the detection the login is showed and after that the page always is reloaded. There are only
                     * two cases, customer proceeds with checkout or goes back to shop.
                     */
                    if(!isNullOrUndefined(currency)) {

                        if(!state.reload) {
                            setUrlParam({ currency: currency });
                        }else {

                            let url = new URL(window.location.href);
                            url.searchParams.set('currency', currency);

                            jQueryGet(url.href)
                                .always(() => {
                                    window.location.reload();
                                });
                        }
                    }else if(state.reload) {
                        window.location.reload();
                    }
                }
            }

            state.shippingCountryId = shippingCountryId;
        },

        setCurrentPriceType(state, priceType)
        {
            state.currentPriceType = priceType;
        },

        setGuestMail(state, guestMail)
        {
            state.guestMail = guestMail;
        },

        setNoSwitchCountry(state, noSwitchCountry)
        {
            state.noSwitchCountry = noSwitchCountry;
        },

        setShippingCountryReload(state, value)
        {
            state.reload = value;
        }
    };

const actions =
    {
        selectShippingCountry({ commit, state }, { shippingCountryId, openBasketPreview })
        {
            return new Promise((resolve, reject) =>
            {
                const oldShippingCountryId = state.shippingCountryId;

                ApiService.post("/rest/io/shipping/country", { shippingCountryId })
                    .done(data =>
                    {
                        if (oldShippingCountryId !== data && openBasketPreview)
                        {
                            setUrlParam({ openBasketPreview: 1 });
                        }

                        commit("setShippingCountryId", shippingCountryId);
                        resolve(data);
                    })
                    .fail(error =>
                    {
                        commit("setShippingCountryId", oldShippingCountryId);
                        reject(error);
                    })
            });
        }
    };

const getters =
    {
        getCountryName: state => countryId =>
        {
            if (countryId > 0)
            {
                const country = state.shippingCountries.find(country => country.id === countryId);

                if (!isNullOrUndefined(country))
                {
                    return country.currLangName;
                }
            }

            return "";
        }
    };

export default
{
    state,
    mutations,
    actions,
    getters
};
